import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type KarteUserConcernKarteFragment = { __typename?: 'Karte', id: string, userComment: string, numberOfPlannerComments: number, hasCommentsFromPlannersBelongingToSameBranch: boolean, modifiedAt: TimeString, channel: Types.Channel, ownKartePlannerComment?: { __typename?: 'KartePlannerComment', comment?: string | null } | null, topics: Array<{ __typename?: 'KarteTopic', id: string, name: string }> };

export const KarteUserConcernKarteFragmentDoc = gql`
    fragment KarteUserConcernKarte on Karte {
  id
  userComment
  ownKartePlannerComment {
    comment
  }
  numberOfPlannerComments
  topics {
    id
    name
  }
  hasCommentsFromPlannersBelongingToSameBranch
  modifiedAt
  channel
}
    `;